import { select } from 'redux-saga/effects';

import { RootStateProps } from '~/context';

export default function state<T = unknown>(fn: (state: RootStateProps) => T) {
  return select(fn);
}
